import React from "react";
import { DashboardDefaultContainer } from "../../dashboard-default-container";
import Header from "../Header";

const EmployeeMeetings = () => {
  
  // list of employees, on selecting the employee, the link can be send to the particular employees to invite to the meeting.
  
  return (
    <DashboardDefaultContainer>
      <div className="">
        <Header title="Meetings & Schedules" href="/hr"/>
      </div>
    </DashboardDefaultContainer>
  );
};

export default EmployeeMeetings;
